
import { Vue, Component, Mixins } from 'vue-property-decorator';
import CheckoutCard from '@/features/shipment/components/checkout/index.vue';
import DetailsFoldout from '@/features/shipment/components/checkout/DetailsFoldout.vue';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { scrollToInPage } from '@/features/common/helpers';
import DetailsFoldoutMixin from '@/features/common/mixins/detailsFoldoutMixin';
import { trackPaymentInitiated } from '@/features/common/helpers/tracked-events';
import { trackEvent } from '@/features/common/helpers/google-analytics';
import { validateInprogressData } from '../helpers/createShipment';
import { AvailableService } from '../types';

@Component({
  components: {
    CheckoutCard,
    DetailsFoldout,
  },
})
export default class Checkout extends Mixins(DetailsFoldoutMixin) {
  get checkoutCard(): HTMLElement {
    return (this.$refs.checkoutCard as Vue).$el as HTMLElement;
  }

  // eslint-disable-next-line class-methods-use-this
  get shipmentSection(): HTMLElement {
    return document.querySelector('.shipment') as HTMLElement;
  }

  created(): void {
    eventBus.$on(eventNames.OPEN_CHECKOUT_DETAILS, this.openDetails);

    eventBus.$on(eventNames.HIDE_CHECKOUT_DETAILS, this.hideDetails);
  }

  async mounted(): Promise<void> {
    scrollToInPage();

    // Fix: fire page_view for SPA route change (checkout page_view was missing)
    trackEvent(this.$gtag, 'page_view', {
      page_title: 'Checkout',
      page_path: this.$route.fullPath,
    });

    // Track payment initiated
    const selectedService = this.$store.getters.getSelectedService as AvailableService | null;
    if (selectedService) {
      trackPaymentInitiated(this.$gtag, {
        value: selectedService.total || 0,
        currency: 'CAD',
        paymentMethod: 'credit_card',
      });
    }

    const { query } = this.$route;
    const isFrom3dsWithError = query.from === '3ds' && query.errorMessage;

    const services = this.$store.state.shipment.availableServices as AvailableService[] | null;
    const shouldShowLoading = !services;

    if (shouldShowLoading) {
      this.$store.commit('setCheckoutLoading', true);
    }

    try {
      if (isFrom3dsWithError) {
        this.resetSelectedService(true);
      } else {
        const isValid = await validateInprogressData();
        this.resetSelectedService(isValid);
      }
    } finally {
      if (shouldShowLoading) {
        this.$store.commit('setCheckoutLoading', false);
      }
    }
  }

  private resetSelectedService(isValidInprogress: boolean): void {
    if (!isValidInprogress) return;

    const services = this.$store.state.shipment.availableServices as AvailableService[] | null;
    const serviceSelected = this.$store.state.shipment.selectedService as AvailableService | null;
    const inProgressData = this.$store.getters.getInProgress;
    const serviceLevel = inProgressData?.serviceLevel;

    if (services && services.length && serviceSelected) {
      const serviceToReplace = services.find(
        (service) => service.selectedService === serviceSelected.selectedService,
      );

      if (serviceToReplace) {
        this.$store.commit('setSelectedService', serviceToReplace);
        return;
      }
    }

    if (services && services.length && serviceLevel) {
      const serviceFromLevel = services.find(
        (service) => service.selectedService === serviceLevel,
      );

      if (serviceFromLevel) {
        this.$store.commit('setSelectedService', serviceFromLevel);
        return;
      }
    }

    this.$router.push({ name: 'shipment-results' });
  }
}
